export const GET_ALL_DETAILS = 'GET_ALL_DETAILS';
export const GET_ALL_DETAILS_SUCCESS = 'GET_ALL_DETAILS_SUCCESS';
export const GET_ALL_DETAILS_FAILED = 'GET_ALL_DETAILS_FAILED';
export const RESET_ALL_DETAILS = 'RESET_ALL_DETAILS';
